<template>
  <KTCard :title="title" :subtitle="subTitle">
    <template v-slot:body>
      <!-- fuente modificacion form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código Fuente Modificación *"
          label-for="codigo"
          description="Escriba el Modificación"
        >
          <b-form-input
            id="codigo"
            v-model="fuenteMod.codigo"
            type="text"
            required
            placeholder="Código Fuente Modificación"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal Fuente Modificación *"
          label-for="literal"
          description="Escriba el literal"
        >
          <b-form-input
            id="literal"
            v-model="fuenteMod.literal"
            type="text"
            required
            placeholder="Literal Fuente Modificación"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_FUENTE_MOD,
  EDIT_FUENTE_MOD
} from "@/core/services/store/fuenteMod.module";

export default {
  name: "fuente-mod-add",
  components: {
    KTCard
  },
  data() {
    return {
      fuenteMod: {
        id: null,
        codigo: "",
        literal: ""
      }
    };
  },
  computed: {
    title() {
      return this.isEdit
        ? "Editar fuente modificación"
        : "Nueva fuente modificación";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  mounted() {
    if (this.isEdit) {
      this.fuenteMod = this.$store.getters.fuenteMod(this.$route.params.id);
    }
  },
  methods: {
    cancel() {
      this.$router.push("/lists/fuente-modificacion");
    },
    onSubmit() {
      if (this.isEdit) {
        this.$store.commit(EDIT_FUENTE_MOD, this.fuenteMod);
      } else {
        this.$store.commit(ADD_FUENTE_MOD, this.fuenteMod);
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
